import { ActionsRender, AvatarDropdown } from '@/settings/components';
import { CompanyListDrawer } from '@/settings/components/HeaderRender/component';
import { PlatformEnum, UserEnum } from '@/settings/enum';
import styles from '@/settings/styles/settings/header-render.less';
import store from '@/store';
import { classes_module } from '@/utils/class-module';
import { isEmpty } from '@/utils/format';
import { AlignLeftOutlined, ProductOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { useSetState } from 'ahooks';
import { Avatar, Tooltip } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Header 导航
 * @param props
 */
export default (props: any) => {
  const { avatarProps, logo, title } = props;
  const { initialState, setInitialState } = useModel('@@initialState');
  const [state, setState] = useSetState({
    realname: '',
    avatar: '',
    title,
    logo,
  });
  const dispatch = useDispatch();
  const companyInfo = useSelector((state: any) => state.platform[PlatformEnum.COMPANY]);
  //  切换菜单抽屉打开/关闭
  function onCollapse() {
    const collapsed = initialState?.collapsed === undefined ? false : !initialState?.collapsed;
    setInitialState({ ...initialState, collapsed });
  }

  useEffect(() => {
    const user_info = store.getState().user[UserEnum.USER_INFO];

    if (!isEmpty(companyInfo)) {
      setState({
        title: companyInfo.short,
        logo: companyInfo.logoBase64,
      });
    }
    if (!isEmpty(user_info)) {
      setState({
        realname: user_info.realname,
        avatar: user_info.avatar || avatarProps.src,
      });
    }
  }, [companyInfo]);

  return (
    <div className={classes_module(styles, 'headerRender-container')}>
      <div className={classes_module(styles, 'headerRender-container-left')}>
        {/* 左侧按钮 */}
        <div className={classes_module(styles, 'headerRender-container-icons')}>
          {/* mobile 模式下显示菜单展开按钮 */}
          <AlignLeftOutlined
            onClick={onCollapse}
            className={classes_module(styles, 'headerRender-container-icon', 'headerRender-container-min-768')}
          />
          <CompanyListDrawer>
            {/* 公司菜单 */}
            <Tooltip title="切换公司" placement="right" trigger="hover">
              <ProductOutlined className={classes_module(styles, 'headerRender-container-icon')} />
            </Tooltip>
          </CompanyListDrawer>
        </div>
        {/* logo + 标题 */}
        <CompanyListDrawer>
          <Tooltip title="切换公司" placement="right" trigger="hover">
            <div className={classes_module(styles, 'headerRender-container-logo')}>
              <Avatar size={{ xs: 24, sm: 28, md: 28, lg: 28, xl: 28, xxl: 28 }} src={state.logo} />
              <div className={classes_module(styles, 'headerRender-container-logo-title')}>{state.title}</div>
            </div>
          </Tooltip>
        </CompanyListDrawer>
        {/*<ProBreadcrumb />*/}
      </div>
      {/* 右侧操作图标 - 用户头像 */}
      <div className={classes_module(styles, 'headerRender-container-right')}>
        {/* 操作图标 */}
        <ActionsRender />
        {/* 用户头像名称 + 下拉选项 */}
        <AvatarDropdown>
          <div className={classes_module(styles, 'headerRender-container-user')}>
            <Avatar
              className={classes_module(styles, 'headerRender-container-avatar')}
              size={{ xs: 24, sm: 28, md: 28, lg: 28, xl: 28, xxl: 28 }}
              src={state.avatar}
            />
            <span className={classes_module(styles, 'headerRender-container-title')}>{state.realname}</span>
          </div>
        </AvatarDropdown>
      </div>
      {/*<CompanyListDrawer open={open} setOpen={setOpen} />*/}
    </div>
  );
};
